// Every watched card address is indexed. The cap keeps per-team indexing
// load bounded and mirrors the backend limit.
export const MAX_CARDS_PER_ORG = 6
